/**
 * @Author: Yu Wang
 * @Date: 2019/3/26 16:37
 * 
 * web端：
    product:kidenglish
    promark:qrXUrFV
    host:kids.youdao.com
    productKey:5773e084312842d5b178897cc71786c5
  移动端：
    product:kidenglish
    promark:mAPLRca
    host:kids.youdao.com
    productKey:5773e084312842d5b178897cc71786c5

    服务名称：Web组件 服务
    产品号：publishtob
    组件ID：mKkhpGm
    host：publish.youdao.com

  https://urs.hz.netease.com/docDetail.html?pid=359#/
  升级4.0版本文档
 */
const loginConfig = {}

const baseKids = {
  product: 'kidenglish',
  promark: 'qrXUrFV',
  host: 'kids.youdao.com',
  productKey: '5773e084312842d5b178897cc71786c5',
  version: 4
}

const basePublish = {
  product: 'publishtob',
  promark: 'mKkhpGm',
  host: 'publish.youdao.com',
  version: 4
}
loginConfig.baseConfig = {
  ...(document.domain.indexOf('publish.youdao.com') !== -1
    ? basePublish
    : baseKids),
  // chromeSupport: 1,
  newCDN: 1, // 代表使用的CDN是连通性更好的SNI域名
  mode: 'popup',
  // 验证码模式，三种模式可选："float"、"embed"、"popup"，即触发式、嵌入式、弹出式。
  // 滑块验证码宽度,不能小于220，建议大点防止被破解,【必须】
  swidth: 'auto',
  /*
                    是否使用HTTPS协议，默认为1，组件的DOM和请求全部使用https协议，
                    如果需要自定义样式，且样式文件所在服务不支持HTTPS，此参数必须出传0，此时Iframe内的DOM以http形式加载，
                    如果不传并且传入的样式表文件地址是HTTP协议，Iframe内文件会被自动降级至HTTP协议；
                    如果样式文件没有https，可参看style属性，避免降级
                    另外，请求依然使用HTTPS协议。如果希望请求使用http协议请参考PROTOCOL参数,REGPROTOCOL
                     */
  // 是否用https，优先级高于PROTOCOL和REGPROTOCOL,【必须】 4.0版本已删除
  isHttps: 1,
  // 邮箱登录，邮箱注册，手机帐号登录，手机帐号注册，锁定状态文案,【可选】
  lockConfig: {
    loginLockTxtMb: '登 录'
  },
  domains: '163.com,126.com', // 登录成功后要设置哪些域cookie
  cookieDomain: 'youdao.com', // 非163域名必选，如果有注册模块，regCookieDomain的值应该一致。
  regCookieDomain: 'youdao.com', // 如果有登录模块，cookieDomain的值应该一致。
  // 【可选】, 样式不闪动，建议确保组件初始化前样式文件加载完成（cssDomain+cssFiles）
  // cssDomain: 'https://shared.ydstatic.com/', // 【可选】,自定义样式的地址，注意：必须是绝对路径，即含有完整的‘http：//’‘https://’协议头
  // cssFiles: 'ydkids/wx/common/urslogin.css', // 【可选】,自定义样式文件:使用样式覆盖方式进行样式自定义。强烈建议，css在head部分预先加载！
  cssDomain: 'https://shared.ydstatic.com/ydkids/wx/', // 【可选】,自定义样式的地址，注意：必须是绝对路径，即含有完整的‘http：//’‘https://’协议头
  // cssDomain: 'https://corp.youdao.com/svn/ydstatic/ydkids/wx/',
  cssFiles: 'common/urslogin.css?v=2020070601', // 【可选】,自定义样式文件:使用样式覆盖方式进行样式自定义。强烈建议，css在head部分预先加载！
  // 验证相关样式更改配置，
  customStyles: {
    //   imagePanel: {
    //     align: "top",
    //     borderRadius: "2px"
    // },
    // controlBar: {
    //     height: "40px",
    //     borderRadius: "2px"
    // },
    // gap: "15px",
    // icon: {
    //     intellisenseLogo: "",
    //     slider: ""
    // }
    imagePanel: {
      align: 'top', // 在float模式下生效，指定imagePanel出现在controlBar上方还是下方。
      borderRadius: '0.2rem' //  imagePanel边框圆角大小
    },
    controlBar: {
      height: '0.88rem', // controlBar的高度
      borderRadius: '0.5rem' // controlBar边框圆角大小
    },
    gap: '0.2rem' // imagePanel和controlBar之间的间隙
  },
  errMode: 1,
  single: 1,
  needEye: 0,
  noqr: 1,

  // 手机验证码登录+注册模块相关配置，统一在uniteLogin对象下
  uniteLogin: {
    loginTxt: '登 录', // 手机验证码登录按钮文案
    first: 1, // 是否统一登录是首屏
    needClause: 0, // 是否需要条款
    placeholders: {
      mob: '请输入11位手机号码',
      sms: '请输入验证码'
    }
  }
}

loginConfig.emailConfig = {
  // 首屏,【可选】,注册:register，登录:login，根据实际情况填入.(此开关配合mobileFirst 可以确定首屏模块)
  page: 'login',
  loginText: '登 录',
  includeBox: 'loginBox2',
  placeholder: {
    account: '网易邮箱账号',
    pwd: '密码'
  }
}

loginConfig.phoneConfig = {
  includeBox: 'loginBox',
  needMobileLogin: 1,
  mobileFirst: 1,
  smsLoginFirst: 1,
  smsBtnTxt: '登 录',
  mbBtnTxt: '登 录', // 手机密码登录按钮文案,【可选】
  mobilePlaceholder: {
    mobile: '请输入11位手机号码', // 手机密码登录文案
    pwd1: '请输入密码' // 手机密码登录文案
  },
  page: 'login'
}

loginConfig.phoneRegCfg = {
  includeBox: 'loginBox3',
  page: 'register',
  regSucCount: 3,
  needMobileReg: 1,
  mobileFirst: 1,
  regMbTxt: '注 册'
}

export default {
  loginConfig
}
